import { useMemo } from 'react';
import { useQueryRefresh } from '../';
import { ir } from '../queries';

function tryParse(s) {
  if (!s || typeof s !== 'string') {
    return null;
  }
  const trimmed = s.trim();
  if (!trimmed || trimmed === '{}' || trimmed === '[]') {
    return trimmed === '[]' ? [] : {};
  }
  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return null;
  }
}

export function useIr(id, allocation = null) {
  const shouldSkip = !id; // Skip query if id is not provided
  const { data, refresh, isLoading, error } = useQueryRefresh(
    ir,
    { id, allocation },
    [],
    false,
    shouldSkip,
  );
  const irData = data?.ir?.edges?.[0]?.node;
  const formatted = useMemo(() => {
    if (!irData) {
      return {};
    }
    const result = { ...irData };
    try {
      const parsedReport = tryParse(irData.report) ?? {};
      result.report = parsedReport;
      result.report.custom_question_responses = tryParse(
        result.report.custom_question_responses,
      );
      result.report.tags = parsedReport.tags;
    } catch (e) {
      console.warn(e);
    }
    result.legacy = tryParse(irData.legacy);
    result.allocation = tryParse(irData.allocation);
    result.tasks = tryParse(irData.tasks);
    return result;
  }, [irData]);
  return { data: formatted, refresh, isLoading, error };
}
